module.exports = __webpack_public_path__ + "img/ob1.97e531ca.png";